module.exports = __webpack_public_path__ + "static/media/barca3.07555d54.gif";